import { createEnv } from "@t3-oss/env-core";
import { z } from "zod";

import { originOnlyUrl } from "@workspace/schemas/url";

export const env = createEnv({
  clientPrefix: "VITE_",
  client: {
    VITE_API_BASE_URL: z.url(),
    VITE_KEYCLOAK_ISSUER: z.url(),
    VITE_ENVIRONMENT: z.enum(["local", "dev", "stg", "prd"]),
    VITE_SENTRY_DSN: z.url().default("https://b0e7c9673fb7282483ff4860d44117ef@o1091361.ingest.us.sentry.io/4510384528162816"),
    VITE_SENTRY_RELEASE: z.string().min(1).optional(),
    VITE_ECLAIM_BASE_URL: z.url(),
    // Joined with an absolute path via `new URL("/eport/v1/...", base)`, so the base must be
    // origin-only — a path prefix would be silently dropped (see originOnlyUrl).
    VITE_CLAIMINI_ADAPTER_BASE_URL: originOnlyUrl,
  },
  runtimeEnv: import.meta.env,
  emptyStringAsUndefined: true,
});
